import { render, staticRenderFns } from "./ClipDetail.vue?vue&type=template&id=c59fab8e"
import script from "./ClipDetail.vue?vue&type=script&lang=js"
export * from "./ClipDetail.vue?vue&type=script&lang=js"
import style0 from "./ClipDetail.vue?vue&type=style&index=0&id=c59fab8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
